<template>
    <LegalAgreementPdfContent :content="previewContent ?? ''" />
</template>

<script setup lang="ts">
    import {createError, useRequestEvent, useRoute, useState} from '#imports';
    import type {LegalAgreementLanguage, LegalAgreementType} from '@api';
    import LegalAgreementPdfContent from '~/components/legal-agreements/LegalAgreementPdfContent.vue';

    const route = useRoute();

    const agreementType = route.params.agreementType as LegalAgreementType;
    const language = route.params.language as LegalAgreementLanguage;

    const previewContent = useState<string | null>(
        `legal-agreement-draft-preview-${agreementType}-${language}`,
        () => useRequestEvent()?.context.legalAgreementDraftPreview ?? null,
    );

    if (previewContent.value === null) {
        throw createError({statusCode: 400, statusMessage: 'Draft preview content is required'});
    }
</script>
